import { render, staticRenderFns } from "./SpinnerLoading.vue?vue&type=template&id=54b24b48&scoped=true&"
var script = {}
import style0 from "./SpinnerLoading.vue?vue&type=style&index=0&id=54b24b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b24b48",
  null
  
)

export default component.exports